<template>
  <div class="pc-news-detail">
    <section class="pc-container breadcrumb">
      <span>公司新闻</span>
      <img :src="icons.right" alt="">
      <span class="current">详情</span>
    </section>
    <section class="pc-container detail-layout">
      <article class="detail-main">
        <div v-if="loading" class="detail-state">加载中...</div>
        <div v-else-if="loadError" class="detail-state">{{ loadError }} <a @click="loadDetail">重试</a></div>
        <template v-else>
        <h1>{{ news.title }}</h1>
        <div class="meta">
          <span>来源：{{ news.source }}</span>
          <span>时间：{{ news.publishDate }}</span>
        </div>
        <div class="content" v-html="news.contentHtml"></div>
        </template>
      </article>

      <aside class="news-side">
        <div class="more-news">
          <h2>更多新闻</h2>
          <button v-for="item in moreNews" :key="item.id" @click="goDetail(item)">
            · {{ item.title }}
          </button>
        </div>
        <div class="ad-card">
          <img :src="sidePoster" alt="商城海报">
        </div>
      </aside>
    </section>
  </div>
</template>

<script>
  import { getPcMallSettings, getPcPublicNewsDetail, getPcPublicNewsList } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'
  import { buildPcDetailPath, decodeRouteCode } from '@/utils/pcRouteCode'

  const pcIcons = {
    right: require('@/assets/icons/pc/chevron-right.svg')
  }

  export default {
    name: 'PcNewsDetail',
    data() {
      return {
        news: commerce.normalizePcNews({}),
        loading: true,
        loadError: '',
        requestVersion: 0,
        moreNews: [],
        sidePoster: '/product-placeholder.png',
        icons: pcIcons
      }
    },
    watch: {
      '$route.params.code': {
        immediate: true,
        handler() {
          this.loadDetail()
          this.loadSidePoster()
        }
      }
    },
    methods: {
      loadSidePoster() {
        getPcMallSettings().then(data => {
          const posters = commerce.normalizePosterImages(data && data.posterImages)
          this.sidePoster = posters[0] || '/product-placeholder.png'
        }).catch(() => {
          this.sidePoster = '/product-placeholder.png'
        })
      },
      loadDetail() {
        const code = this.$route.params.code
        const id = decodeRouteCode('news', code) || (/^[1-9]\d*$/.test(String(code)) ? Number(code) : '')
        const version = ++this.requestVersion
        this.loadError = ''
        this.loading = true
        if (!id) {
          this.loadError = '新闻链接无效'
          this.loading = false
          return
        }
        getPcPublicNewsDetail(id).then(data => {
          if (version !== this.requestVersion) return
          if (!data || !data.id) throw new Error('新闻不存在或已下架')
          this.news = commerce.normalizePcNews(data || {})
        }).catch(error => {
          if (version === this.requestVersion) this.loadError = error.message || '新闻加载失败'
        }).finally(() => { if (version === this.requestVersion) this.loading = false })
        getPcPublicNewsList({ page: 1, pageSize: 10 }).then(data => {
          const records = data && data.records ? data.records : []
          this.moreNews = records.map(commerce.normalizePcNews).slice(0, 8)
        }).catch(() => {
          this.moreNews = []
        })
      },
      goDetail(item) {
        this.$router.push(buildPcDetailPath('news', item.id))
      }
    }
  }
</script>

<style scoped>
  .pc-news-detail {
    min-height: calc(100vh - 206px);
    padding-bottom: 70px;
    background: #f7f7f7;
  }

  .breadcrumb {
    height: 46px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 7px;
  }

  .breadcrumb img {
    width: 12px;
    height: 12px;
  }

  .breadcrumb .current {
    color: #008bea;
  }

  .detail-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 414px;
    gap: 12px;
  }

  .detail-main {
    min-height: 650px;
    background: #fff;
  }

  .detail-state { padding: 100px 20px; text-align: center; color: #778195; }

  .detail-main h1 {
    margin: 0;
    padding: 26px 50px 18px;
    border-bottom: 1px solid #eee;
    text-align: center;
    color: #111827;
    font-size: 21px;
    font-weight: 400;
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .meta {
    height: 54px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #eee;
    color: #778195;
  }

  .meta span {
    display: block;
  }

  .content {
    padding: 24px 20px 40px;
    color: #344054;
    font-size: 16px;
    line-height: 1.65;
  }

  .content >>> p {
    margin: 0 0 24px;
  }

  .content >>> img {
    display: block;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .news-side {
    display: grid;
    gap: 12px;
    align-content: start;
  }

  .more-news {
    padding: 18px;
    background: #fff;
  }

  .more-news h2 {
    margin: 0 0 14px;
    padding-left: 8px;
    border-left: 3px solid #008bea;
    font-size: 16px;
  }

  .more-news button {
    display: block;
    width: 100%;
    height: 28px;
    border: 0;
    background: #fff;
    color: #475569;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .ad-card {
    aspect-ratio: 79 / 55;
    overflow: hidden;
    background: #fff;
  }

  .ad-card img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
</style>

